<template>
    <div>
        <table-tool-bar>
            <template slot="left">
                <table-searcher v-model="filter.orderNo"
                    placeholder="请输入工单号、执行人姓名"
                    :width="250"
                    style="margin-left: 10px;"
                    @search="search"></table-searcher>
                <label style="margin-left: 20px">服务类别</label>
                <Select v-model="filter.serviceType"
                    :class="preCls + 'select-public-style'"
                    transfer
                    clearable
                    @on-change="search">
                    <Option v-for="(item, index) in serviceTypeList"
                        :value="item.id"
                        :key="index">{{item.text}}</Option>
                </Select>
                <label>状态</label>
                <check-tag-group style="display: inline-block; margin-left: 20px"
                    multiple
                    checkAll
                    v-model="orderStatus"
                    color="primary">
                    <check-tag v-for="item in orderStatusList"
                        :name="item.id"
                        :key="item.id">{{item.text}}</check-tag>
                </check-tag-group>
            </template>
        </table-tool-bar>
        <Table ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight">
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button type="default"
                    size="small"
                    style="margin-right: 5px;"
                    @click="rowClickInfo(row)">详情</Button>
                <Button v-if="$can('setLeader')"
                    type="default"
                    size="small"
                    style="margin-right: 5px;"
                    @click="rowClickAssign(row)">指定领导</Button>
                <Button v-if="$can('distribute')"
                    type="default"
                    size="small"
                    style="margin-right: 5px;"
                    @click="rowClickExecute(row)">派单执行</Button>
                <PoptipButton v-if="$can('delete')"
                    text="删除"
                    transfer
                    type="default"
                    title="确认删除该条记录?"
                    :ok="() => { rowConfirmDel(row) }"></PoptipButton>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"></table-pager>
        <!-- 弹出层 -->
        <smart-modal v-model="modal.showInfo"
            :title="curId ? '工单详情' : '工单登记'"
            :width="800"
            :height="650"
            :maskClosable="false"
            :buttons.sync="formBtns"
            @close-by-confirm="search">
            <form-info v-if="modal.showInfo"
                :id="curId"></form-info>
        </smart-modal>
        <smart-modal v-model="modal.showAssign"
            title="指定领导"
            :width="600"
            :height="240"
            :maskClosable="false"
            @close-by-confirm="search">
            <form-assign v-if="modal.showAssign"
                :id="curId"></form-assign>
        </smart-modal>
        <smart-modal v-model="modal.showExecute"
            title="派单执行"
            :width="600"
            :height="240"
            :maskClosable="false"
            @close-by-confirm="search">
            <form-execute v-if="modal.showExecute"
                :id="curId"></form-execute>
        </smart-modal>
    </div>
</template>
<script>
import { mapCell, pipeCell } from '_c/grid/renderCell'
import FormInfo from '../form-order'
import FormAssign from './form-assign'
import FormExecute from './form-execute'
import { orderList, orderDelete } from '@/api/order-manage'
import Dict from '_u/dict'

const PAGE_SIZE = 20

export default {
    name: 'ListOrderWait',

    components: {
        FormInfo,
        FormAssign,
        FormExecute
    },
    props: {
        date: Object
    },
    data() {
        return {
            mtHeight: 360,
            loading: false,
            filter: {
                pageNo: 1,
                pageSize: PAGE_SIZE,
                orderDataSource: 'G',
                orderNo: this.$cache.orderNo || '',
                serviceType: this.$cache.serviceType || '',
                orderStatus: this.$cache.orderStatusWait || ''
            },
            // 待派工单
            waitStatus: ['1', '2'],
            page: {
                total: 0,
                list: []
            },
            dict: {
                orderStatus: Dict.NULL,
                busType: Dict.NULL,
                serviceType: Dict.NULL
            },
            modal: {
                showInfo: false,
                showAssign: false,
                showExecute: false
            },
            curId: '',
            formBtns: []
        }
    },

    computed: {
        columns() {
            return [{
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60
                },
                {
                    key: 'orderNo',
                    title: '工单号',
                    align: 'left',
                    minWidth: 180
                },
                {
                    key: 'customerName',
                    title: '客户名称',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: 'serviceType',
                    title: '服务类别',
                    align: 'center',
                    width: 100,
                    render: mapCell(this.dict.serviceType.val())
                },
                {
                    key: 'orderStatus',
                    title: '状态',
                    align: 'center',
                    width: 100,
                    render: mapCell(this.dict.orderStatus.val())
                },
                {
                    key: 'assignUserName',
                    title: '指定领导',
                    align: 'left',
                    minWidth: 100
                },
                {
                    key: 'createUserName',
                    title: '报单人',
                    align: 'center',
                    minWidth: 100
                },
                {
                    key: 'createUserPhone',
                    title: '报单电话',
                    align: 'center',
                    minWidth: 120
                },
                {
                    key: 'contactName',
                    title: '联系人',
                    align: 'left',
                    minWidth: 120
                },
                {
                    key: 'contactPhone',
                    title: '联系电话',
                    align: 'left',
                    minWidth: 120
                },
                {
                    key: 'execUserName',
                    title: '执行人',
                    align: 'center',
                    minWidth: 100
                },
                {
                    key: 'execUserPhone',
                    title: '执行电话',
                    align: 'center',
                    minWidth: 120
                },
                {
                    key: 'createTime',
                    title: '报单时间',
                    align: 'center',
                    minWidth: 150,
                    render: pipeCell('ymdL')
                },
                {
                    key: 'planCompleteTime',
                    title: '要求完成时间',
                    align: 'center',
                    minWidth: 150,
                    render: pipeCell('ymdL')
                },
                {
                    key: 'addr',
                    title: '实施地址',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 280,
                    fixed: 'right',
                    slot: 'action'
                }
            ]
        },

        orderStatusList() {
            return this.dict.orderStatus
                .val()
                .filter(el => this.waitStatus.includes(el.id))
        },

        orderStatus: {
            get() {
                return this.filter.orderStatus.split(',').filter(el => el)
            },
            set(el) {
                this.filter.orderStatus = el.join(',')
                this.search()
            }
        },

        serviceTypeList() {
            return this.dict.serviceType.val()
        },

        serviceType: {
            get() {
                return this.filter.serviceType.split(',').filter(el => el)
            },
            set(el) {
                this.filter.serviceType = el.join(',')
            }
        }
    },

    watch: {
        'filter.orderStatus': function(val) {
            this.$cache.orderStatusWait = val
        },
        'filter.serviceType': function(val) {
            this.$cache.serviceType = val
        },
        'filter.orderNo': function(val) {
            this.$cache.orderNo = val
        },
        date: {
            handler(val) {
                this.search()
            },
            deep: true
        }
    },

    created() {
        Promise.all([Dict.get(['order_status', 'bus_type', 'service_type'])])
            .then(args => {
                var [dictGroup, page] = args
                Object.keys(this.dict).forEach(name => {
                    this.dict[name] = dictGroup[name]
                })
            })
            .then(args => {
                this.fetch()
            })
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },

    methods: {
        fetch() {
            this.loading = true
            let date = Object.assign({}, this.date),
                body = Object.assign(date, this.filter)
            if (!body.orderStatus) {
                body.orderStatus = this.waitStatus.join(',')
            }
            Promise.all([orderList(body)])
                .then(args => {
                    var [page] = args
                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        search() {
            this.filter.pageNo = 1
            this.fetch()
        },

        setPageData(data) {
            let list = data.page.list
            list.forEach(el => {
                el.cellClassName = {
                    orderStatus: `order-status-color${el.orderStatus || 999}`
                }
            })
            this.page.list = list
            this.page.total = parseInt(data.page.totalCount)
        },

        rowClickInfo(row) {
            this.curId = row.id
            this.modal.showInfo = true
        },

        rowClickAssign(row) {
            this.curId = row.id
            this.modal.showAssign = true
        },

        rowClickExecute(row) {
            this.curId = row.id
            this.modal.showExecute = true
        },

        rowConfirmDel(row) {
            this.loading = true
            orderDelete(row.id)
                .then(res => {
                    this.$Message.success(this.$t('tips.delete.success'))
                })
                .finally(() => this.fetch())
        }
    }
}
</script>
<style lang="less"
    scoped>
</style>